import React from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { DASHBOARD_ROLES, ROUTES } from '@/routes/paths';

export function RoleGuard() {
  const { role } = useParams();
  const { user } = useAuth();

  const validRole = role && DASHBOARD_ROLES.includes(role) ? role : null;

  if (!validRole && user) {
    return <Navigate to={ROUTES.dashboard(user.role)} replace />;
  }

  if (validRole && user && user.role !== validRole) {
    return <Navigate to={ROUTES.dashboard(user.role)} replace />;
  }

  return <Outlet />;
}
